export default "__VITE_ASSET__7L226g1F__"